import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Button, Row } from 'tdesign-react';
import { CLUSTER_TYPES } from '@/utils/constant';
import {
  QUICK_DEPLOY_STEPS,
  setQuickDeployClusterType,
  setQuickDeployStep,
} from '@/slices/clusterSlice';
import DisableWrapper from '@/components/DisableWrapper';

function SelectClusterTypeStep({ clusterType, setQuickDeployClusterType, setQuickDeployStep }) {
  const goNext = () => {
    if (clusterType === CLUSTER_TYPES.HOST) {
      setQuickDeployStep(QUICK_DEPLOY_STEPS.CHOICE_CLUSTER);
    } else {
      setQuickDeployStep(QUICK_DEPLOY_STEPS.MAINTAIN_K8S);
    }
  };

  return (
    <Root>
      <Body>
        <Card
          active={clusterType === CLUSTER_TYPES.HOST}
          onClick={() => setQuickDeployClusterType(CLUSTER_TYPES.HOST)}
        >
          <Image src={require('./images/img1.png')} />
          <Title active={clusterType === CLUSTER_TYPES.HOST}>虚拟机/物理机集群</Title>
        </Card>

        <Card
          active={clusterType === CLUSTER_TYPES.K8S}
          onClick={() => setQuickDeployClusterType(CLUSTER_TYPES.K8S)}
        >
          <Image src={require('./images/img2.png')} />
          <Title active={clusterType === CLUSTER_TYPES.K8S}>容器集群</Title>
        </Card>
      </Body>
      <Row justify='end' style={{ marginTop: 20 }}>
        <DisableWrapper>
          <Button onClick={goNext}>下一步</Button>
        </DisableWrapper>
      </Row>
    </Root>
  );
}

export default connect(
  (state) => ({
    clusterType: state.cluster.quickDeploy.clusterType,
  }),
  {
    setQuickDeployClusterType,
    setQuickDeployStep,
  },
)(SelectClusterTypeStep);

const Root = styled.div``;

const Body = styled.div`
  padding: 30px 30px 0;
  display: flex;
`;

const Card = styled.div`
  width: 180px;
  height: 170px;
  cursor: pointer;
  margin: 0 20px;
  background: #ffffff;
  border: 1px solid #e4e6ea;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${(props) =>
    props.active &&
    `
    background: #FAFBFF;
    border: 1px solid #194DFF;
    box-shadow: 0px 0px 0px 3px rgba(25, 77, 255, 0.15);
  `}
`;

const Image = styled.img`
  width: 100px;
  height: 100px;
  margin-top: 20px;
`;

const Title = styled.div`
  text-align: center;
  font-size: 14px;
  line-height: 22px;
  color: ${(props) => (props.active ? '#194DFF' : '#8F959F')};
  margin-top: 16px;
`;
